import { Button, InlineError, Spinner } from 'avo-ui'
import icArrowLeft from 'assets/images/ic-arrow-left.svg'
import Select from 'components/commons/select'

export const ColumnMapping = ({
    isLoading,
    columnListExcel,
    options,
    errorForm,
    prevStepHandler,
    onChangeForm,
    getValue,
    onSubmit,
}) => {
    return (
        <div className={'w-5/6 flex flex-col space-y-4 text-neutral-80 border rounded-lg'}>
            <div className={'flex flex-col space-y-6 p-6'}>
                <Button className={'w-fit px-8'} title={'Back'} icon={icArrowLeft} onClick={prevStepHandler} />
                <div className={'space-y-2'}>
                    <p className={'text-lg text-blue-90'}>Import Product From XLSX File</p>
                    <p>This tools allows you to import (or merge) Product data to Product list from a XLSX file.</p>
                </div>
            </div>
            <div className={'flex flex-wrap text-blue-90 border-y'}>
                <div className={'w-full font-bold flex p-6'}>
                    <p className={'basis-1/2'}>Column Name</p>
                    <p className={'basis-1/2'}>Map to Field</p>
                </div>
                {isLoading ? (
                    <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
                ) : (
                    Object.keys(columnListExcel).map((item, index) => (
                        <div key={index} className={'w-full flex px-6 py-4 even:bg-blue-5'}>
                            <div className={'flex flex-col space-y-2 basis-1/2 pr-5'}>
                                <p className={'font-semibold'}>{item}</p>
                                <p className={'italic text-neutral-60 line-clamp-2'}>Sample: {columnListExcel[item]}</p>
                            </div>
                            <div className={'flex flex-col space-y-3 basis-1/2'}>
                                <Select
                                    name={item}
                                    className={'flex-1'}
                                    optionsClassName={'max-h-40'}
                                    placeholder={'Pilih column database'}
                                    options={options}
                                    value={getValue(item)}
                                    searchable
                                    onChange={onChangeForm}
                                />
                                <InlineError className='mt-2' message={errorForm?.[item]} />
                            </div>
                        </div>
                    ))
                )}
            </div>
            <div className={'flex pb-4 justify-center'}>
                <Button className={'px-12'} title={'Next'} onClick={onSubmit} />
            </div>
        </div>
    )
}
